/** Centralized route path definitions. All client-side routes in one place. */

export const ROUTES = {
  login: '/login',
  home: '/',
  expenses: '/expenses',
  expenseDetail: (id: string) => `/expenses/${id}`,
  expenseEdit: (id: string) => `/expenses/${id}/edit`,
} as const
